import ErrorMessage from "lib/ErrorMessage";
import Image from "lib/Image";
import Label from "lib/Label";
import DatePicker from "react-date-picker";
import Calender from "assets/images/calender.svg";
import x from "assets/images/x.svg"
import "./index.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { setSelectedData } from "redux/formDisplay";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";

const DateComponent = (props) => {
  const {
    name,
    value,
    label,
    onChange,
    class_name,
    error,
    placeholder,
    events,
    //Donot remove selectedData as it is being used from the config in the eval part of code below
    selectedData,
    size,
    is_disabled,
    disable_date,
    validators,
    isEditable, // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
    default_value, // Specify the value in Months
    onLoad,
    default_future_date,
  } = props;

  const mandatoryExtraction = useSelector(
    (state) => state?.formData?.mandatoryExtraction
  );
  const [minDate, setMinDate] = useState();
  const [maxDate, setMaxDate] = useState();
  const [date, setDate] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [dateError,setDateError] = useState(null)
  let validFrom = selectedData?.[name?.replace("to", "from")];
  if (name.includes("valid_from")) validFrom = null;

  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";

  const dispatch = useDispatch();

  useEffect(() => {
    if (default_future_date && !selectedData[name]) {
      let newDate = new Date();
      newDate?.setMonth(newDate.getMonth() + default_future_date);
      let new_date = moment(newDate).format("DD/MM/YYYY");
      onLoad(name, new_date);
    } else if (default_value && !selectedData[name]) {
      let new_date = moment(default_value).format("DD/MM/YYYY");
      if (new_date) {
        onLoad(name, new_date);
      }
    }
  }, []);

    const handleChange = (newDate) => {
      if (newDate instanceof Date && !isNaN(newDate.getTime())) {
        if (newDate.getFullYear() < 1000) {
          setDateError("Invalid year, it should be greater than 1000")    
          }
        else{
          setDateError(null)
        }
        setDate(newDate);
        onChange(newDate.toISOString(), name);
      }
      if (newDate) {
        let saveDate = true;
        if (saveDate) onChange(moment(newDate).format("DD/MM/YYYY"), name);
        handleInputChange(moment(newDate));
      }
    };
    
  const handleInputChange = (enteredDateString) => {
    // Check if entered date is empty
    if (!enteredDateString) {
      return;
    }
    const parsedDate = moment(enteredDateString, "DD/MM/YYYY", true); // Strict parsing

    setDate(parsedDate);
    onChange(parsedDate.format("DD/MM/YYYY"), name);

    // if (parsedDate.isValid()) {
    //   setDate(parsedDate);
    //   onChange(parsedDate.format("DD/MM/YYYY"), name);
    //   console.log("parsedDate",parsedDate)
    // } else {
    //   // console.log("Invalid date format");
    //   const currentYear = moment().format("YYYY");
    //   const correctedDate = `${enteredDateString.substring(
    //     0,
    //     6
    //   )}${currentYear}`;
    //   console.log("correctedDate",correctedDate);
    //   handleInputChange(correctedDate);
    // }
  };

  let dateArray = [];
  let ValidFromArray = [];
  let dataValue = value && value?.split("/");
  value && dateArray.push(dataValue[1]);
  value && dateArray.push(dataValue[0]);
  value && dateArray.push(dataValue[2]);

  let dataValidfrom = validFrom && validFrom?.split("/");
  validFrom && ValidFromArray.push(dataValidfrom[1]);
  validFrom && ValidFromArray.push(dataValidfrom[0]);
  validFrom && ValidFromArray.push(dataValidfrom[2]);

  const handleOpenCalender = () => {
    const currentDate = new Date();
    if (name.includes("valid_from")) {
      setMinDate(new Date());
    } else if (name.includes("valid_to")) {
      setMaxDate(new Date());
    }
    if (props?.next_max_days && props?.disable_date) {
      const numberOfDaysMin = parseInt(props.next_max_days);
      if (!isNaN(numberOfDaysMin) && numberOfDaysMin > 0) {
        const maxDate = new Date(currentDate);
        maxDate.setDate(currentDate.getDate() + numberOfDaysMin);
        setMaxDate(maxDate);
        setMinDate();
      }
    }
    if (props?.next_max_days && !props?.disable_date) {
      const numberOfDaysMin = parseInt(props.next_max_days);
      if (!isNaN(numberOfDaysMin) && numberOfDaysMin > 0) {
        const minDate = new Date(currentDate);
        minDate.setDate(currentDate.getDate() + numberOfDaysMin);
        setMinDate(minDate);
      }
    }

    if (props?.prev_max_days) {
      const numberOfDaysMax = parseInt(props.prev_max_days);
      if (!isNaN(numberOfDaysMax) && numberOfDaysMax > 0) {
        const maxDate = new Date(currentDate);
        maxDate.setDate(currentDate.getDate() - numberOfDaysMax);
        setMaxDate(maxDate);
      }
    }
  };

  return (
    <div className={size}>
      <Label label={label} validators={validators} />
      <div className="date_container">
        <DatePicker
          onChange={handleChange}
          format="dd/MM/yyyy"
          maxDate={minDate}
          minDate={maxDate}
          className={`input_date ${errorClass} ${class_name} ${
            !isEditable && "radioDisabled"
          }`}
          onCalendarOpen={handleOpenCalender}
          value={
            date !== null
              ? moment(date, "DD/MM/YYYY").toDate()
              : value
              ? moment(value, "DD/MM/YYYY").toDate()
              : null
          }
          onKeyDown={(e) => {
            dispatch(setSelectedData({ key: name, value: null }));
          }}
          clearIcon= {
            <Image
              imageSrc={x}
              className="clear-button"
              onClick={() => {
                setDate(null);
                onChange(null, name);
                // setFormErr((prev) => ({ ...prev, [name]: null }));
              }
                }
            ></Image>
          }
          calendarIcon={
            <Image
              imageSrc={Calender}
              className="input_date_calender"
              onClick={(showCalendar) => setShowCalendar(!showCalendar)}
            />
          }
          disabled={!isEditable}
        />
        {/* <p>Selected date: {date ? date.toString() : ""}</p> */}
        {error?.length !== 0 && <ErrorMessage error={error} />}
        {dateError?.length !== 0 && <ErrorMessage error={dateError}/>}
      </div>
    </div>
  );
};

export default DateComponent;
